import { useFormContext, useWatch } from 'react-hook-form';
import { PanelInfo } from '@/components/custom';
import { ScrollArea } from '@/components/ui';
import { ShieldCheck } from 'lucide-react';
import { TFormData } from '.';

const FormEditUserRolesBodyRoot = () => {

  const { control } = useFormContext<TFormData>();
  const username = useWatch({ control, name: 'username' });

  return (
    <ScrollArea className='flex-1 overflow-auto flex flex-col py-3 px-0 md:px-5'>
      <PanelInfo
        title='Utilisateur root'
        description={
          <p>
            <span className='text-purple-600'>{username}</span> à accès à toutes les fonctionnalités du système.
          </p>
        }
        className='py-5 md:py-20 border-none'
        iconClassName='text-green-500'
        icon={ShieldCheck} />
    </ScrollArea>
  );

};

export default FormEditUserRolesBodyRoot;
